import { DialogActions, DialogContent, DialogTitle, Divider, IconButton } from "@mui/material"
import { CloseOutlined } from "@mui-symbols-material/w300"
import type { FC, ReactNode } from "react"
import React from "react"

import { Button } from "@/components/common/Button"

interface RolesDialogContentProps {
  isSubmitDisabled: boolean
  children: ReactNode
  title: string
  handleCancel: () => void
  handleSave: () => void
}

const RolesDialogContent: FC<RolesDialogContentProps> = ({
  title,
  handleCancel,
  handleSave,
  isSubmitDisabled,
  children,
}) => {
  return (
    <>
      <DialogTitle className='pl-10 font-normal text-primary'>{title}</DialogTitle>
      <IconButton aria-label='close' onClick={handleCancel} className='absolute right-4 top-4 text-primary'>
        <CloseOutlined />
      </IconButton>
      <Divider />
      <DialogContent classes={{ root: "p-10" }}>{children}</DialogContent>
      <DialogActions className='justify-between px-10 pb-10'>
        <Button appearance='outlined' onClick={handleCancel}>
          Cancel
        </Button>
        <Button disabled={isSubmitDisabled} onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </>
  )
}

export default RolesDialogContent
